<template>
  <workbench-w-canvas-slot :loading="loading"
                           :metrics="toolbarMetrics"
                           :target-name="targetName"
                           :activated="activated"
                           :header-menu="dynamicHeaderMenu"
                           :showQuickAddAttributes="showQuickAddAttributes">
    <template v-if="isTargetEmpty && !loading">
      <div class="workbench__empty-target">
        <h3 v-if="isTargetEmpty">Select a Program by Searching or Browsing from the right panel.</h3>
      </div>
    </template>

    <template v-else>
      <workbench-row ref="viewership" :style="{ height: viewershipRowHeight}">

        <audience-size class="workbench__audience workbench__canvas-block" :size="audienceSize"></audience-size>

        <div class="workbench__canvas-block workbench__viewership">
          <viewership :networks="networks"
                      :show-filter="false"
                      :viewership-data="historicalViewership"></viewership>
        </div>

      </workbench-row>

      <workbench-row v-if="selectedNetworksDayParts.length > 0">
        <day-parts class="workbench__day-parts workbench__canvas-block"
                   :viewership-data="historicalViewership"
                   :selected-networks="selectedNetworksDayParts"
                   :networks="networks"
                   :day-parts-config="dayPartsConfig"
                   @close="clearSelectedNetworks"
        ></day-parts>
      </workbench-row>

      <workbench-row ref="universe" :style="{ height: universeRowHeight}" class="workbench__universe">

        <universe-stability class="workbench__canvas-block"
                            :universe="universeData"
                            :hide-stability-flag="true"></universe-stability>

      </workbench-row>
    </template>

    <confirm-modal ref="confirmModal"/>

  </workbench-w-canvas-slot>
</template>

<script>
  import { ResizeSensor } from 'css-element-queries'
  import WorkbenchWCanvasSlot from '@/views/workbenchCanvas/WorkbenchWCanvasSlot'
  import ConfirmModal from '@/appComponents/oldWorkbench/confirmModal/ConfirmModal'
  import WorkbenchRow from '@/views/workbenchCanvas/WorkbenchRow'
  import AudienceSize from '@/appComponents/oldWorkbench/audienceSize/AudienceSize'
  import UniverseStability from '@/appComponents/workbench/lasGraphs/universeStability'
  import Viewership from '@/appComponents/graphs/viewership'
  import DayParts from '@/appComponents/oldWorkbench/dayParts/DayParts'
  import { isEmpty } from 'lodash'
  import {CLOSE_DAY_PARTS_SECTION} from '@/appLogic/targets/currentTarget/store/actions'
  import CommonMixins from '@/views/workbench/mixins/CommonWorkbenchMixins'
  import {
    INTENTS, ACTIVATION_STATUS
  } from '@/appLogic/targets/Constants'

  export default {
    components: {
      WorkbenchWCanvasSlot,
      WorkbenchRow,
      AudienceSize,
      UniverseStability,
      DayParts,
      Viewership,
      ConfirmModal
    },
    mixins: [CommonMixins],
    data () {
      return {
        viewershipRowHeight: null,
        universeRowHeight: null,
        namespace: 'ad'
      }
    },
    computed: {
      targetDefinition () {
        return this.$store.getters.targetDefinition
      },
      isTargetEmpty () {
        return !!this.targetDefinition && !!this.targetDefinition.query && isEmpty(this.targetDefinition.query)
      },
      dateRange () {
        return this.$store.state.ad.dateRange.availableDates
      },
      audienceSize () {
        return this.universeData && this.universeData.audienceSize ? this.universeData.audienceSize : this.$store.state.ad.audienceSize
      },
      historicalViewership () {
        return this.$store.state.ad.historicalViewership
      },
      networks () {
        return this.$store.getters.networks
      },
      selectedNetworksDayParts () {
        return this.$store.getters.networksToShowDayParts
      },
      dayPartsConfig () {
        return this.$store.state.ad.dayParts
      },
      universeData () {
        return this.$store.state.ad.universe
      },
      showQuickAddAttributes () {
        if (this.$store.currentTarget) {
          let intents = this.$store.currentTarget && this.$store.currentTarget.metadata && this.$store.currentTarget.metadata.intents || []
          let hasMarketingIntent = intents.filter(x => x.IntentId === INTENTS.Marketing.IntentId).length > 0
          return !hasMarketingIntent
        }
      },
      activated () {
        if (this.$store.state.currentTarget.currentTarget) {
          return this.$store.state.currentTarget.currentTarget.activation_status === ACTIVATION_STATUS.ACTIVATED
        }
      }
    },
    methods: {
      clearSelectedNetworks () {
        this.$store.dispatch(CLOSE_DAY_PARTS_SECTION)
      },
      setRowSizes () {
        let canvasHeight = this.canvasEl.clientHeight
        let vp = 0.7
        let up = 0.3
        // canvas graphs min height
        if (canvasHeight < 480) {
          canvasHeight = 480
        }
        // help fit universe graph on smaller screens
        if (canvasHeight < 650) {
          vp = 0.6
          up = 0.4
        }
        this.viewershipRowHeight = canvasHeight * vp - 15 + 'px'
        this.universeRowHeight = canvasHeight * up - 15 + 'px'
      }
    },
    mounted () {
      // eslint-disable-next-line no-undef
      adobeAnalytics.viewADWorkbench()
      this.canvasEl = document.querySelector('#canvas')
      document.querySelector('html').classList.add('workbench-resize')
      this.setRowSizes()
      ResizeSensor(this.canvasEl, () => {
        this.setRowSizes()
      })
    }
  }
</script>

<style lang="scss">
  $side-panel-width: rem(380);
  $audience-size-width: rem(140);
  $margin-size: rem(10);


  .workbench {

    &__empty-target {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: white;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__viewership {
      position: relative;
      width: calc(100% - #{$audience-size-width + $margin-size});
    }

    .viewership-block {
    }

    &__day-parts {
      flex: 1 100%;
      max-width: 100%;
    }

    &__canvas-block {
      position: relative;
      box-sizing: border-box;
      background: #ffffff;
      padding: rem(20);
      @include drop-shadow;

      & + & {
        margin-left: $margin-size;
      }
    }

    &__audience {
      width: $audience-size-width;
      flex: none;
    }

    &__universe {
      position: relative;
      width: 100%;
    }

    &__show-level-table {

      .overlay__content {
        height: 50%;
        width: 80%;
      }
    }

    &__show-level-checklist {
      .overlay__content {
        /*height: 460px;*/
        width: 400px;
      }

      .show-level-checklist {
        box-sizing: border-box;
        padding: 32px;
        overflow: hidden;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Ad.vue?d8bfe424